import { Button, Grid, Stack } from "@mui/material";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import CreateOrEdit from "@/controller/CreateOrEdit";
import WithSave from "@/controller/WithSave";
import { InfoTypeResponseDto } from "@/gen/api/secureai";
import { OdResourcePageProps } from "@/types/resource";
import { push } from "connected-react-router";
import InfoTypeEditor from "@/components/secureai/InfoTypeEditor";
import { useDefaultSavedHandlers } from "@/controller/defaultSavedHandlers";
import usePermitGuard from "@/authProvider/usePermitGuard";
import { MANAGE_SECUREAI_SETTINGS } from "@/constants";
import { useCreateZTreeStore } from '@/utils/zustand-form/store';
import { ZTreeStoreProvider } from '@/utils/zustand-form/store.context';
import { CollectEditsProtocol } from '@/utils/zustand-form/ext/collectEdits';
import { useStore } from "zustand";
import { FormNode } from "@/utils/zustand-form/types";




const SecAiCreateInfoType: FC<OdResourcePageProps> = (props) => {
  usePermitGuard([[MANAGE_SECUREAI_SETTINGS]])
  
  return (
    <CreateInfoTypeBody {...props} />
  )
}

const CreateInfoTypeBody: FC<OdResourcePageProps> = ({
  options, resource,
}) => {
  const dispatch = useDispatch()

  // Create zstore for InfoTypeEditor
  const zstore = useCreateZTreeStore();

  const handleSave = (save: (record:any,callbacks?:any)=>Promise<InfoTypeResponseDto>) => async () => {
    try {
      // Use CollectEditsProtocol to collect data from zustand store
      const payload = await CollectEditsProtocol.invoke(
        (protocol) => zstore.getState().invokeNodeProtocol('root', protocol) as any
      );

      const data = await save(payload)
      dispatch(push(`/${resource}/${data.id}/show`))
    } catch (error) {
      return
    }
  }
  const dirty = useStore(zstore, state => {
    let hasChanges = Object.values(state.getNode('root')?.state.touched ?? {}).some(x => x)
    if (hasChanges) { return true }
    state.traverseDescendants('root', (next) => {
      let childNode : FormNode|null = null 
      while (!hasChanges && (childNode = next())) {
        hasChanges = Object.values(childNode.state.touched).some(x => x)
      }
    })
    return hasChanges
  })

  const handlers = useDefaultSavedHandlers("Create Info Type")

  return (
    <Grid container spacing={4} >
      <Helmet>
        <title>Create Info Type | OnData</title>
      </Helmet>
      <Grid item xs={12}>
        <ZTreeStoreProvider value={zstore}>
          <InfoTypeEditor title="New Info Type"
            action={
              <Stack direction="row" spacing={2}>
                <Button color="primary" variant="outlined" component={RouterLink} size="small"
                  to={`/${resource}`}
                >
                  Cancel
                </Button>
                <CreateOrEdit resource={resource} basePath="" {...handlers}>
                  <WithSave async
                    render={({save, saving}) =>
                      <Button color="primary" variant="contained" size="small"
                        disabled={saving || !dirty}
                        onClick={handleSave(save)}
                      >
                        Save
                      </Button>}
                  />
                </CreateOrEdit>
              </Stack>
            }
          />
        </ZTreeStoreProvider>
      </Grid>
    </Grid>
  )
}

export default SecAiCreateInfoType;

const emptyPrevData = Object.freeze({})
